import lodash from 'lodash';
import {trans} from '../../systems/i18n';
import queryString from 'query-string';
import {url} from '../../systems/routing/index';

export default {
    statusLabel: (status) => trans('complaintSeller:status.' + lodash.toLower(status)),
    urlList: (query = {}) => url.to('complaint-seller') + '?' + queryString.stringify(query, {arrayFormat: 'bracket'}),
};
